import {
  IsString,
  IsNotEmpty,
  IsOptional,
  IsBoolean,
  IsUUID,
  IsInt,
  Min,
  MaxLength,
  IsDateString,
} from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class CreateModuleDto {
  @ApiProperty({
    example: 'liquidaciones-vd',
    description: 'Código único del módulo',
  })
  @IsString()
  @IsNotEmpty()
  @MaxLength(50)
  readonly code!: string;

  @ApiProperty({
    example: 'Liquidaciones VD',
    description: 'Nombre del módulo',
  })
  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  readonly name!: string;

  @ApiPropertyOptional({
    example: 'Módulo de liquidaciones de valor declarado',
    description: 'Descripción del módulo',
  })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  readonly description?: string;

  @ApiPropertyOptional({
    example: '/liquidaciones-vd',
    description: 'Ruta del módulo',
  })
  @IsOptional()
  @IsString()
  @MaxLength(100)
  readonly route?: string;

  @ApiPropertyOptional({
    example: 'dollar-sign',
    description: 'Nombre del ícono (feather icons)',
  })
  @IsOptional()
  @IsString()
  @MaxLength(50)
  readonly icon?: string;

  @ApiProperty({
    example: 1,
    description: 'Orden de visualización del módulo',
  })
  @IsInt()
  @Min(0)
  readonly order!: number;

  @ApiPropertyOptional({
    example: 'VD',
    description: 'Grupo de menú al que pertenece el módulo',
  })
  @IsOptional()
  @IsString()
  @MaxLength(50)
  readonly menuGroup?: string;

  @ApiPropertyOptional({
    example: true,
    description: 'Indica si el módulo está activo',
    default: true,
  })
  @IsOptional()
  @IsBoolean()
  readonly isActive?: boolean;
}

export class UpdateModuleDto {
  @ApiPropertyOptional({
    example: 'Liquidaciones VD',
    description: 'Nombre del módulo',
  })
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  readonly name?: string;

  @ApiPropertyOptional({
    example: 'Módulo de liquidaciones de valor declarado',
    description: 'Descripción del módulo',
  })
  @IsOptional()
  @IsString()
  @MaxLength(255)
  readonly description?: string;

  @ApiPropertyOptional({
    example: '/liquidaciones-vd',
    description: 'Ruta del módulo',
  })
  @IsOptional()
  @IsString()
  @MaxLength(100)
  readonly route?: string;

  @ApiPropertyOptional({
    example: 'dollar-sign',
    description: 'Nombre del ícono (feather icons)',
  })
  @IsOptional()
  @IsString()
  @MaxLength(50)
  readonly icon?: string;

  @ApiPropertyOptional({
    example: 1,
    description: 'Orden de visualización del módulo',
  })
  @IsOptional()
  @IsInt()
  @Min(0)
  readonly order?: number;

  @ApiPropertyOptional({
    example: 'VD',
    description: 'Grupo de menú al que pertenece el módulo',
  })
  @IsOptional()
  @IsString()
  @MaxLength(50)
  readonly menuGroup?: string;

  @ApiPropertyOptional({
    example: true,
    description: 'Indica si el módulo está activo',
  })
  @IsOptional()
  @IsBoolean()
  readonly isActive?: boolean;
}

export class ModuleResponseDto {
  @ApiProperty({
    example: '123e4567-e89b-12d3-a456-426614174000',
    description: 'ID único del módulo',
  })
  @IsUUID()
  readonly id!: string;

  @ApiProperty({
    example: 'liquidaciones-vd',
    description: 'Código único del módulo',
  })
  @IsString()
  readonly code!: string;

  @ApiProperty({
    example: 'Liquidaciones VD',
    description: 'Nombre del módulo',
  })
  @IsString()
  readonly name!: string;

  @ApiPropertyOptional({
    example: 'Módulo de liquidaciones de valor declarado',
    description: 'Descripción del módulo',
  })
  @IsOptional()
  @IsString()
  readonly description?: string;

  @ApiPropertyOptional({
    example: '/liquidaciones-vd',
    description: 'Ruta del módulo',
  })
  @IsOptional()
  @IsString()
  readonly route?: string;

  @ApiPropertyOptional({
    example: 'dollar-sign',
    description: 'Nombre del ícono',
  })
  @IsOptional()
  @IsString()
  readonly icon?: string;

  @ApiProperty({
    example: 1,
    description: 'Orden de visualización',
  })
  @IsInt()
  readonly order!: number;

  @ApiPropertyOptional({
    example: 'VD',
    description: 'Grupo de menú',
  })
  @IsOptional()
  @IsString()
  readonly menuGroup?: string;

  @ApiProperty({
    example: true,
    description: 'Indica si el módulo está activo',
  })
  @IsBoolean()
  readonly isActive!: boolean;

  @ApiProperty({
    example: '2024-01-15T10:30:00Z',
    description: 'Fecha de creación',
  })
  @IsDateString()
  readonly createdAt!: string;

  @ApiPropertyOptional({
    example: '2024-01-15T10:30:00Z',
    description: 'Fecha de última actualización',
  })
  @IsOptional()
  @IsDateString()
  readonly updatedAt?: string;
}
